import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getTimeFromUTCToTimezone } from '../../../shared/utils/getTimeFromUTCToTimezone';
import { formateNumber } from 'shared/helpers';

dayjs.extend(customParseFormat);
export class ReportsApiConverter {
  convertStatisticProvider = data => {
    let arrProviders = [];
    arrProviders = Object.keys(data.providers).map(el => ({
      provider: el,
      betCount: formateNumber(data.providers[el].bet_count),
      betAmount: formateNumber(data.providers[el].bet_amount),
      winAmount: formateNumber(data.providers[el].win_amount),
      commissionBalance: formateNumber(data.providers[el]?.commission_balance ?? 0),
      incomeAmount: formateNumber(data.providers[el].income_amount),
    }));

    const detail = {
      betCount: formateNumber(data.detail.total_bet_count),
      betAmount: formateNumber(data.detail.total_bet),
      winAmount: formateNumber(data.detail.total_won),
      incomeAmount: formateNumber(data.detail.total_income),
      commissionBalance: formateNumber(data.detail?.commission_balance ?? 0),
      lastCalculateTime: data.detail?.last_calculate_time
        ? dayjs(data.detail?.last_calculate_time).add(-3, 'hour').format('DD.MM.YYYY HH:mm')
        : '',
      margin: formateNumber(data.detail?.margin) ?? '0',
    };

    return {
      providers: arrProviders,
      detail,
    };
  };

  convertPaymentHistory = data => {
    let arrTransfers = [];
    arrTransfers =
      data?.transfers?.map(el => ({
        id: el?.id,
        operation: el?.operation,
        amount: formateNumber(el?.amount),
        fromUser: el?.from_user,
        toUser: el?.to_user,
        initiatorUser: el?.initiator_user,
        realToUser: el?.real_to_user,
        createdAt: getTimeFromUTCToTimezone(dayjs(el?.created_at, 'YYYY-MM-DDTHH:mm:ss'))?.format('DD/MM/YY HH:mm'),
        balanceFrom: formateNumber(el?.balance_changes.balance_from),
        balanceTo: formateNumber(el?.balance_changes.balance_to),
      })) || [];

    return {
      transfers: arrTransfers,
      details: {
        totalCount: data?.details?.total_count,
        totalDeposit: formateNumber(data?.details?.total_deposit || data?.totals?.total_deposit || 0),
        totalWithdraw: formateNumber(data?.details?.total_withdraw || data?.totals?.total_withdraw || 0),
        lastCalculateTime: data.details?.last_calculate_time
          ? dayjs(data.details.last_calculate_time).add(-3, 'hour').format('DD.MM.YYYY HH:mm')
          : '',
        balance: formateNumber(
          data?.details?.total_deposit && data?.details?.total_withdraw
            ? data.details.total_deposit - data.details.total_withdraw
            : data?.totals?.total_withdraw && data?.totals?.total_deposit
            ? data.totals.total_deposit - data.totals.total_withdraw
            : 0,
        ),
        deltaBalance: formateNumber(data?.details?.delta_balance || data?.totals?.delta_balance || 0),
      },
    };
  };

  convertPaymentHistoryTotals = data => {
    return {
      totalDeposit: formateNumber(data?.totals?.total_deposit || 0),
      totalWithdraw: formateNumber(data?.totals?.total_withdraw || 0),
      lastCalculateTime: data.details?.last_calculate_time
        ? dayjs(data.details?.last_calculate_time).add(-3, 'hour').format('DD.MM.YYYY HH:mm')
        : '',
      balance: formateNumber(
        data?.totals?.total_withdraw && data?.totals?.total_deposit
          ? Number(data.totals.total_deposit) - Number(data.totals.total_withdraw)
          : 0,
      ),
      deltaBalance: formateNumber(data?.details?.delta_balance || data?.totals?.delta_balance || 0),
    };
  };

  convertStatisticPlayer = data => {
    let arrStatistics = [];
    arrStatistics = Object.keys(data.user_statistic).map(el => ({
      id: el,
      name: data.user_statistic[el].email,
      amountIn: formateNumber(data.user_statistic[el].amount_in),
      amountOut: formateNumber(data.user_statistic[el].amount_out),
      total: formateNumber(data.user_statistic[el].total),
    }));

    return {
      userStatistic: arrStatistics,
      details: {
        totalCount: /* formateNumber */ data.details.total_count,
      },
    };
  };

  convertSlotsHistory = data => {
    let arrData = [];
    arrData = data.data.map(el => ({
      id: el.id,
      date: getTimeFromUTCToTimezone(dayjs(el.date, 'YYYY-MM-DDTHH:mm:ss'))?.format('DD/MM/YY HH:mm'),
      player: el.username,
      provider: el.provider,
      amount: formateNumber(el.amount),
      prevBalance: formateNumber(el.balance_before),
      afterBalance: formateNumber(el.balance_after),
      status: el.status,
      // userId: el.user_id,
      // gameType: el.gameType,
    }));

    return {
      data: arrData,
      totalCount: /* formateNumber */ data.totalCount,
    };
  };

  convertBetsHistory = data => {
    let arrData = [];
    arrData = data.data.map(el => ({
      couponId: el.note,
      date: getTimeFromUTCToTimezone(el.date)?.format('DD/MM/YY'),
      user: el.username,
      type: el.status,
      amount: formateNumber(el.amount),
      balanceBefore: formateNumber(el.balance_before),
      balanceAfter: formateNumber(el.balance_after),
      // userId: el.user_id,
      // isExpress: el.is_express,
      // currency: el.currency,
      // bets: el.bets,
      // totalCoeff: el.total_coeff,
      // winAmount: el.win_amount,
    }));

    return {
      data: arrData,
      count: /* formateNumber */ data.totalCount,
    };
  };

  convertFinanceHistory = data => {
    let arrTransfers = [];
    arrTransfers = data.transfers.map(el => ({
      id: el?.id,
      operation: el?.operation === 0 ? 'deposit' : 'withdrawal',
      // fromUserId: el?.from_user_id,
      // toUserId: el?.to_user_id,
      fromUser: el?.from_user,
      toUser: el?.to_user,
      currency: el?.currency,
      createdAt: getTimeFromUTCToTimezone(el?.created_at)?.format('DD/MM/YY'),
      balanceBeforeFromUser: formateNumber(el?.additional_data.balance_before_from_user),
      balanceBeforeToUser: formateNumber(el?.additional_data.balance_before_to_user),
      balanceAfterFromUser: formateNumber(el?.additional_data.balance_after_from_user),
      balanceAfterToUser: formateNumber(el?.additional_data.balance_after_to_user),
    }));

    return {
      transfers: arrTransfers,
      details: {
        totalCount: /* formateNumber */ data.details.total_count,
      },
    };
  };

  convertRequestHistory = data => {
    return {
      count: data.count,
      data:
        data?.items?.map(el => ({
          createdAt: getTimeFromUTCToTimezone(dayjs(el?.created_at, 'YYYY-MM-DDTHH:mm'))?.format('DD/MM/YY HH:mm'),
          id: el?.id,
          username: el?.username,
          operation: el?.type,
          bank: {
            id: el?.bank?.id,
            titular: el?.bank?.titular,
            details: el?.bank?.details,
            bank: el?.bank?.bank,
          },
          phoneNumber: el?.phone_number,
          amount: formateNumber(el?.amount),
          comment: el?.comment,
          bankHolder: el?.name,
          status: el?.status,
          type: el?.type,
          promoCodePercent: el?.promo_code_percent,
        })) || [],
    };
  };

  convertCashbackHistory = data => {
    function formatNumberString(numberStr) {
      const number = parseFloat(numberStr);
      return new Intl.NumberFormat('ru-RU', {
        maximumFractionDigits: 0,
      }).format(number);
    }

    return {
      paid: formatNumberString(data.paid),
      toBePaid: formatNumberString(data.to_be_paid),
      accumulated: formatNumberString(data.accumulated),
      count: data.count,
      data:
        data?.data.map(el => ({
          date: getTimeFromUTCToTimezone(dayjs(el?.date, 'YYYY-MM-DDTHH:mm'))?.format('HH:mm DD.MM.YYYY'),
          id: el?.id,
          username: el?.username,
          amount: el?.amount,
          cashbackPercent: el?.cashback_percent,
        })) || [],
    };
  };
}
